import React from 'react';

export default function MailTo(props) {
  const email = props.email;
  return (
    <a href={`mailto:${email}`} className="links">
      {email}
    </a>
  );
}
